import * as React from "react";
import {
  Dialog,
  DialogProps,
  DialogTitle,
  IconButton,
  makeStyles,
  Paper,
  PaperProps,
  Theme,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Cancel";
import Draggable from "react-draggable";
import { IEnumerable } from "../../core/models/ModelHelpers";
import uuidv4 from "../../helpers/uuid";

type styleProps = {
  draggable?: boolean;
};

const useStyles = makeStyles<Theme, styleProps>((theme: Theme) => ({
  root: ({ draggable = true }) => ({
    position: "relative",
    cursor: draggable ? "move" : "unset",
  }),

  icon: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
}));

type SimpleDialogProps = {
  id?: IEnumerable;
  draggable?: boolean;
  title?: React.ReactNode;
  children?: React.ReactNode;
  // eslint-disable-next-line @typescript-eslint/ban-types
  handleClose?: () => void;
} & DialogProps;

function SimpleDialog({
  draggable = true,
  title,
  children,
  id,
  handleClose,
  ...others
}: SimpleDialogProps) {
  const classes = useStyles({ draggable });
  const useId = `#draggable-dialog-${id || uuidv4()}`;
  const theme = useTheme();
  const isMobileResolution = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      id={useId}
      PaperComponent={!isMobileResolution && draggable ? PaperComponent : Paper}
      maxWidth="xs"
      fullWidth
      aria-labelledby={useId}
      onClose={handleClose}
      {...others}
    >
      <DialogTitle id={useId} className={classes.root}>
        {title}
        <IconButton onClick={handleClose} className={classes.icon}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      {children}
    </Dialog>
  );
}

function PaperComponent({ id, ...props }: PaperProps) {
  return (
    <Draggable handle={id} cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

export default SimpleDialog;
